import React from 'react'
import { Button, Card, CardHeader, Col, Row } from 'reactstrap';

const SelectProviderListItem = ({
    mutate,
    avatar,
    title,
    alternativeName,
    onDeleteAction,
    onSeeAction,
    id,
    selected,
    selectedProvider,
    onEditAction,
    options,
    createdAt,
    onSelect,
    ...rest
}) => {

    return (
        <Card className='shadow-none border-top p-0' data-testid="ProviderItem">
            <Button color={`falcon-default`} className="border-none shadow-none text-left p-0" onClick={onSelect}>
                <CardHeader className={selected === id ? 'bg-secondary' : ''} style={{ background: 'none' }}>
                    <Row>
                        <Col className="d-flex align-items-center">
                            <div className="media-body">
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">{title}</span>
                                </h6>
                                <p className="m-0">Proveedor</p>
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
            </Button>
        </Card>
    )
}

export default SelectProviderListItem;